
export default "/assets/document-text-micro.590b69ea.svg"